import { createSlice, nanoid } from '@reduxjs/toolkit';

const initialState = [
  { id: nanoid(), make: 'Toyota', model: 'Corolla', year: 2019, plate: 'ABC-1234', status: 'Available' },
  { id: nanoid(), make: 'Honda',  model: 'Civic',   year: 2020, plate: 'XYZ-5678', status: 'In Service' },
  { id: nanoid(), make: 'Ford',   model: 'Focus',   year: 2018, plate: 'FOC-9012', status: 'Available' },
  { id: nanoid(), make: 'Tesla',  model: 'Model 3', year: 2022, plate: 'TES-3456', status: 'Rented' },
  { id: nanoid(), make: 'BMW',    model: 'X1',      year: 2021, plate: 'BMW-7890', status: 'Available' },
];

const carSlice = createSlice({
  name: 'cars',
  initialState,
  reducers: {
    addCar: {
      reducer(state, action) {
        state.push(action.payload);
      },
      prepare({ make, model, year, plate, status }) {
        return {
          payload: {
            id: nanoid(),
            make,
            model,
            year,
            plate,
            status
          }
        };
      }
    },
    updateCar(state, action) {
      const idx = state.findIndex(c => c.id === action.payload.id);
      if (idx !== -1) state[idx] = { ...state[idx], ...action.payload };
    },
    deleteCar(state, action) {
      return state.filter(c => c.id !== action.payload);
    }
  }
});

export const { addCar, updateCar, deleteCar } = carSlice.actions;
export default carSlice.reducer;
